import { PRODUCT_TYPES_MAPPER } from './orderFormBase';

export const ORDER_TYPES = {
	market: { name: 'Market', value: 'RL-MKT', testId: 'market' },
	limit: { name: 'Limit', value: 'RL', testId: 'limit' },
	stoploss: { name: 'SL', value: 'SL', testId: 'sl' },
	stoplossMarket: { name: 'SL-M', value: 'SL-MKT', testId: 'slm' },
};

export const DEEP_LINK_ORDER_TYPES_MAP = {
	MARKET: ORDER_TYPES.market,
	LIMIT: ORDER_TYPES.limit,
	STOPLOSS: ORDER_TYPES.stoploss,
	STOPLOSS_MARKET: ORDER_TYPES.stoplossMarket,
};

export const ORDER_TYPES_LIST = [
	ORDER_TYPES.market,
	ORDER_TYPES.limit,
	ORDER_TYPES.stoploss,
	ORDER_TYPES.stoplossMarket,
];

export const AMO_DISABLED_PRODUCTS = [PRODUCT_TYPES_MAPPER.mtf.id, PRODUCT_TYPES_MAPPER.btst.id];
export const IOC_DISABLED_PRODUCTS = [PRODUCT_TYPES_MAPPER.mtf.id, PRODUCT_TYPES_MAPPER.btst.id];

export const VALIDITY_TYPE = {
	DAY: {
		name: 'Day',
		value: 'DAY',
	},
	IMMEDIATE: {
		name: 'Immediate',
		value: 'IOC',
	},
	EOTODY: {
		name: 'Day',
		value: 'EOTODY',
	},
};

export const TRANSACTION_TYPE = {
	BUY: 'BUY',
	SELL: 'SELL',
	SIP: 'SIP',
	MODIFY_BUY: 'MODIFY_BUY',
	MODIFY_SELL: 'MODIFY_SELL',
	MODIFY_SIP: 'MODIFY_SIP',
};

export const ORDER_BUTTON_TITLE = {
	[TRANSACTION_TYPE.BUY]: 'SWIPE TO BUY',
	[TRANSACTION_TYPE.SELL]: 'SWIPE TO SELL',
	[TRANSACTION_TYPE.SIP]: 'SWIPE TO START SIP',
	[TRANSACTION_TYPE.MODIFY_BUY]: 'SWIPE TO MODIFY BUY',
	[TRANSACTION_TYPE.MODIFY_SELL]: 'SWIPE TO MODIFY SELL',
	[TRANSACTION_TYPE.MODIFY_SIP]: 'SWIPE TO MODIFY SIP',
};

export const DEFAULT_ORDER_FORM_DATA = {
	quantity: '1',
	price: '0',
	disclosedQuantity: '0',
	validity: VALIDITY_TYPE.DAY.value,
	orderType: ORDER_TYPES.market.value,
	isAmo: false,
	stoplossTrigger: '',
	quantityChangedManual: false,
	priceChangedManual: false,
	quantityVariableUsed: false,
	priceVariableUsed: false,
};

export const FIELD_IDENTIFIER = {
	quantity: 'quantity',
	price: 'price',
	stoploss: 'stoplossTrigger',
	disclosedQuantity: 'disclosedQuantity',
};

export const DEFAULT_SIP_FORM_DATA = {
	quantity: '1',
	priceCap: '',
	frequency: 'WEEKLY',
	noOfInstallments: '6',
	startDate: '',
	date: '',
	showPriceCap: false,
	day: 'MONDAY',
	selectedIndex: 1,
	quantityChangedManual: false,
	priceChangedManual: false,
	quantityVariableUsed: false,
	priceVariableUsed: false,
};

export const SIP_FIELD_IDENTIFIERS = {
	quantity: 'quantity',
	priceCap: 'priceCap',
	noOfInstallments: 'noOfInstallments',
	startDate: 'startDate',
};

export const LEG_INDICATOR_MAPPER = {
	NORMAL: 1,
	TWO_LEG: 5,
	THREE_LEG: 6,
	SPREAD: 4,
};

export const ORDER_FORM_ERROR = {
	validQty: 'Enter a valid quantity',
	zeroQty: 'Quantity cannot be 0',
	validPrice: 'Enter a valid Price',
	zeroPrice: 'Price cannot be 0',
	qtyMultipleOfLot: 'Quantity should be a multiple of the lot size',
	limitPriceTick: 'Price should be a multiple of tick size',
	limitPriceDpr: 'Limit Price should be within DPR',
	triggerLowerThanLimit: 'Trigger price should be lower than the Limit price',
	triggerGreaterThanLmit: 'Trigger Price should be greater than Limit Price',
	triggerInDpr: 'Trigger Price should be within DPR',
	triggerMultipleOfPriceTick: 'Trigger Price should be multiple of tick size',
	triggerGreaterThanLtp: 'Trigger price should be greater than the last traded price',
	triggerLowerThanLtp: 'Trigger price should be lower than the Last traded price',
	disclosedQtyGratedThanOrder: 'Disclosed quantity cannot be greater than order quantity',
	aomWithIocNotAllowed: 'AMO orders with IOC validity are not allowed',
};

// const mktFlag = isMarketOrStopLossMarketOrder ? 1 : 0;
export const BUY_SELL_FLAG_MAPPER = {
	[TRANSACTION_TYPE.BUY]: 1,
	[TRANSACTION_TYPE.SELL]: 2,
};

export const EVENTS_PRICE_TYPE_MAPPER = {
	'RL-MKT': 'market',
	RL: 'limit',
	SL: 'sl',
	'SL-MKT': 'sl-m',
};
